var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterfallSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#EBEDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 28V26M22 28V25M27 28V23M12.5 22C12.5 17.5217 12.5 15.2825 13.8912 13.8912C15.2825 12.5 17.5217 12.5 22 12.5C26.4783 12.5 28.7175 12.5 30.1088 13.8912C31.5 15.2825 31.5 17.5217 31.5 22C31.5 26.4783 31.5 28.7175 30.1088 30.1088C28.7175 31.5 26.4783 31.5 22 31.5C17.5217 31.5 15.2825 31.5 13.8912 30.1088C12.5 28.7175 12.5 26.4783 12.5 22Z",
    stroke: "#384BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9922 21.4863C18.1473 21.5581 23.0341 21.2328 25.8137 16.8213M23.9923 16.2884L25.8678 15.9865C26.0964 15.9574 26.432 16.1379 26.5145 16.353L27.0104 17.9914",
    stroke: "#384BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterfallSvg);
export default __webpack_public_path__ + "static/media/WaterfallSvg.6266360087b9c08e80dd3a793e94e21e.svg";
export { ForwardRef as ReactComponent };